module.exports = __webpack_public_path__ + "static/media/logoblack.3609157d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/logoblack.png
// module id = 63
// module chunks = 0